function store_api_credentials_locally(clientId, clientSecret, name) {
    jQuery('body').isLoading();
    localStorage.setItem(`${name}_client_id`, clientId);
    localStorage.setItem(`${name}_client_secret`, clientSecret);

    jQuery('form[action="/logout"]').submit();
    return false;
}

jQuery(document).ready(function($) {
    const isStandalone = window.location.hash === '#standalone' || ('standalone' in window.navigator && window.navigator.standalone);
    if (DigitalPresence.isUsedForDigitalPresence()) {
        // if url is not starting with /digital-presence then redirect to /digital-presence
        if (!window.location.pathname.startsWith('/digital-presence')) {
            window.location.href = '/digital-presence';
        } else {
            const digitalPresence = new DigitalPresence();
            // You just got forwarded from the settings page, and need to assist people to add to home screen
            if (!isStandalone) {
                // get the clientId and secret, and add it to the url, without redirecting
                const clientId = localStorage.getItem('Digital Presence_client_id');
                const clientSecret = localStorage.getItem('Digital Presence_client_secret');
                const url = new URL(window.location.href);
                url.searchParams.set('client_id', clientId);
                url.searchParams.set('client_secret', clientSecret);
                window.history.replaceState({}, '', url);

                // Remove the keys from localStorage
                localStorage.removeItem('Digital Presence_client_id');
                localStorage.removeItem('Digital Presence_client_secret');

                digitalPresence.init(true);
            } else {
                remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: ---- PAGE LOAD ----`);
                digitalPresence.init();
            }
        }
    } else {
        if (window.location.pathname.startsWith('/digital-presence')) {
            // get client_id and client_secret from searchParams, set them in localStorage, and reload the screen

            const url = new URL(window.location.href);
            const clientId = url.searchParams.get('client_id');
            const clientSecret = url.searchParams.get('client_secret');
            if (isStandalone && clientId && clientSecret) {
                store_api_credentials_locally(clientId, clientSecret, 'Digital Presence');
                window.location.reload();
            } else {
                window.location.href = '/login';
            }
        }
    }
});

const PRESENCE_SCREEN_TRANSITION_TIME = 250;

class DigitalPresence {
    constructor() {
        this.api = new StandaloneAPI('/api/digital-presence', 'Digital Presence');
    }

    init(showSetup = false) {

        jQuery('body').addClass('digital-presence');

        this.wrapper = jQuery('.presence-screens');
        this.wrapper.show();
        this.settings = JSON.parse(this.wrapper.attr('data-settings'));

        this.watchInvalidInputs();

        this.wrapper.find('#birthday').dateOnlyInput();

        this.applyLogo();

        this.debug = false;

        this.notifyErrors();

        if (showSetup) {
            this.loadSetupScreen();
        } else {
            this.watchInternetConnection();
            // this.initHardReloadFunction();
            this.initDebugTrigger();
            this.loadInitScreen();
        }
    }

    loadSetupScreen() {
        this.activateScreen('setup');
    }

    initDebugTrigger() {
        // const whiteBall = jQuery('<div />');
        // whiteBall.css({
        //     position: 'fixed',
        //     top: '5px',
        //     left: '5px',
        //     width: '10px',
        //     height: '10px',
        //     background: 'white',
        //     borderRadius: '50%',
        //     pointerEvents: 'none',
        //     zIndex: 10000,
        // });
        // jQuery('body').append(whiteBall);

        // this.clickedForDebug = 0;
        // jQuery('.presence-screen#initial .initial-text-wrapper').click(function() {
        //     this.clickedForDebug = (this.clickedForDebug || 0) + 1;
        //     console.log(this.clickedForDebug);
        //     if (this.clickedForDebug === 5) {
        //         this.debug = true;
        //         jQuery('body').addClass('debug');
        //         this.clickedForDebug = 0;
        //     }
        // });
        // jQuery('.presence-screen#initial >:not(.initial-text-wrapper)').click(() => {
        //     this.clickedForDebug = 0;
        // });
    }

    watchInternetConnection() {
        this.online = window.navigator.onLine;
        window.addEventListener('online', () => {
            this.online = true;
            jQuery('body').removeClass('offline');
        });
        window.addEventListener('offline', () => {
            this.online = false;
            jQuery('body').addClass('offline');
        });
        // check if online when tab gets focused again
        jQuery(window).focus(() => {
            this.online = window.navigator.onLine;
            jQuery('body').toggleClass('offline', !this.online);
        });
    }

    initHardReloadFunction() {
        // When the screen has been pressed for 5 seconds straight, reload the page
        let pressed = false;
        let timeout = null;
        jQuery('html').on('pointerdown', () => {
            pressed = true;
            this.clearTimeout(timeout, 'reloadTimeout');
            timeout = this.setTimeout(() => {
                window.location.reload();
            }, 5000, 'reloadTimeout');
        }).on('pointerup', () => {
            pressed = false;
            this.clearTimeout(timeout, 'reloadTimeout');
        }).on('pointermove', () => {
            this.clearTimeout(timeout, 'reloadTimeout');
            if (pressed) {
                timeout = this.setTimeout(() => {
                    window.location.reload();
                }, 5000, 'reloadTimeout');
            }
        });
    }

    showGuidedAccessAlert() {
        const guidedAccessAlert = jQuery('.guided-access-alert');
        guidedAccessAlert.addClass('show');
        guidedAccessAlert.find('button').click(() => {
            guidedAccessAlert.remove();
            return false;
        });
    }

    loadInitScreen() {
        const screen = this.activateScreen('initial');

        this.showGuidedAccessAlert();

        if (this.resetCountdown) this.clearInterval(this.resetCountdown, 'resetCountdown');
        if (this.resetTimeout) this.clearTimeout(this.resetTimeout, 'resetTimeout');

        this.wrapper.removeClass('about-to-reset');
        jQuery('body')
            .unbind('pointerdown')
            .unbind('pointermove')
            .unbind('keydown');

        this.lastName = null;
        this.confirmedNotToBeStudentId = null;

        const button = screen.find('.init-button');
        button.unbind('click').click(() => {
            this.startResetTimeout();
            this.loadBirthdayConfirmationScreen();
            return false;
        })
    }

    /**
     * Screen for entering the birthday
     */
    loadBirthdayConfirmationScreen() {
        const screen = this.activateScreen('birthday-confirmation');

        const confirmButton = screen.find('.confirm-button');
        confirmButton.unbind('click').click(async () => {
            remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: User clicked on confirm button on screen birthday-confirmation`);
            this.startLoading();
            const studentsWithThisBirthDay = await this.findTodaysStudentBy('birthday', screen.find('#birthday').val());
            this.stopLoading();
            this.foundStudents = studentsWithThisBirthDay;
            if (studentsWithThisBirthDay.length === 1) {
                this.loadStudentFoundScreen(studentsWithThisBirthDay[0]);
            } else {
                this.loadLastnameConfirmationScreen();
            }
        });
    }

    /**
     * Screen for entering the last name
     */
    loadLastnameConfirmationScreen() {
        const screen = this.activateScreen('lastname-confirmation');

        const confirmButton = screen.find('.confirm-button');
        confirmButton.unbind('click').click(async () => {
            remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: User clicked on confirm button on screen lastname-confirmation`);
            this.lastName = screen.find('#lastname').val();
            this.startLoading();
            const studentsWithThisLastName = (await this.findTodaysStudentBy('last_name', this.lastName, this.foundStudents.map((student) => student.id)))
                .filter((student) => {
                    return student.id !== this.confirmedNotToBeStudentId;
                });
            this.stopLoading();
            this.foundStudents = _.uniqBy([...studentsWithThisLastName, ...this.foundStudents], 'id');
            if (studentsWithThisLastName.length === 1) {
                this.loadStudentFoundScreen(studentsWithThisLastName[0]);
            } else if (studentsWithThisLastName.length > 1) {
                this.loadMultipleStudentsFoundScreen();
            } else {
                this.loadNoStudentFoundScreen();
            }
        });
    }

    /**
     * Screen that shows multiple people with the same birthday and/or last name, let the user select one
     */
    loadMultipleStudentsFoundScreen() {
        const students = this.foundStudents;
        const screen = this.activateScreen('multiple-students-found');

        const submitButton = screen.find('.confirm-button');
        submitButton.unbind('click').click(() => {
            remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: User clicked on confirm button on screen multiple-students-found`);
            if (!this.online) return;
            const selectedId = screen.find('input:checked').val();
            const selectedStudent = students.find((student) => {
                return student.id === parseInt(selectedId);
            });
            this.confirmStudent(selectedStudent);
        })
        submitButton.attr('disabled', 'disabled');

        const inputWrapper = screen.find('.input-wrapper');
        inputWrapper.children(':not(:nth-child(1))').remove();
        students.map((student, index) => {
            let row = inputWrapper.find('.student-row:first');
            if (index > 0) {
                row = row.clone();
                inputWrapper.append(row);
            }
            this.fillStudentRow(row, student, false, false);

            row.find('input').unbind('change').change(function() {
                submitButton.removeAttr('disabled');
            });
        });
    }

    /**
     * Screen that shows the student that was found
     */
    loadStudentFoundScreen(student) {
        const screen = this.activateScreen('student-found');

        const row = screen.find('.student-row');
        this.fillStudentRow(row, student, true);

        const confirmButton = screen.find('.confirm-button');
        confirmButton.unbind('click').click(() => {
            remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: User clicked on confirm button on screen student-found`);
            this.confirmStudent(student);
        });

        const cancelButton = screen.find('.cancel-button');
        cancelButton.unbind('click').click(async () => {
            remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: User clicked on cancel button on screen student-found`);
            this.confirmedNotToBeStudentId = student.id;

            if (this.foundStudents.length > 1 && this.lastName) {
                // If user says he's not this person, and you found other students, refetch without birthday combination
                this.startLoading();
                const studentsWithThisLastName = await this.findTodaysStudentBy('last_name', this.lastName);
                this.stopLoading();
                this.foundStudents = _.uniqBy([...studentsWithThisLastName, ...this.foundStudents], 'id').filter((foundStudent) => {
                    return foundStudent.id !== student.id;
                });
                this.loadMultipleStudentsFoundScreen();
            } else if (this.lastName) {
                this.loadNoStudentFoundScreen();
            } else {
                this.loadLastnameConfirmationScreen();
            }
            return false;
        });
    }

    async confirmStudent(student) {
        this.stopResetTimeout();

        this.startLoading();
        await this.api.refreshCsrfTokenIfNeeded();
        await Promise.all(student.appointments.map((appointments) => {
            return this.post(`markPresent/${student.id}/${appointments.id}`);
        }));
        const welcomeHTMLText = await this.get(`welcomeText/${student.id}`);
        this.stopLoading();

        const screen = this.activateScreen('welcome-page');
        screen.find('.welcome-text-wrapper').html(welcomeHTMLText);

        this.autoCloseScreen(screen, this.settings.showWelcomeTextTime);
    }


    /**
     * Screen that shows no student was found
     */
    loadNoStudentFoundScreen() {
        this.stopResetTimeout();
        const screen = this.activateScreen('no-student-found');

        this.autoCloseScreen(screen, this.settings.showCloseTextTime);
    }

    autoCloseScreen(screen, time) {
        remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: Auto closing screen ${screen.attr('id')} in ${time} seconds`);
        screen.find('.seconds').text(time);

        const backToStart = () => {
            this.clearInterval(this.resetCountdown, 'resetCountdown');
            this.loadInitScreen();
        }

        this.resetCountdown = this.setInterval(() => {
            const seconds = screen.find('#close-seconds');
            const units = screen.find('#close-units');
            const secondsValue = parseInt(seconds.text());
            if (secondsValue === 1) {
                remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: Auto closing screen ${screen.attr('id')}`);
                backToStart();
            } else {
                screen.find('.seconds').text(secondsValue - 1);
                units.text(secondsValue - 1 === 1 ? 'seconde' : 'seconden');
            }
        }, 1000, 'resetCountdown');

        screen.find('button').unbind('click').click(() => {
            remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: User clicked on screen ${screen.attr('id')}`);
            backToStart();
        });
    }

    fillStudentRow(row, student, checked = false, includeAppointments = true) {
        row.find('.student-name').text(student.messageName);
        row.find('tr.company-info').toggle(!!student.company);
        if (student.company) {
            row.find('.student-company-name').text(student.company.name);
        }
        row.find('tr.appointments-info').toggle(includeAppointments);
        if (includeAppointments) {
            const appointmentStrings = student.appointments.map((appointment) => {
                return `${appointment.start_time} - ${appointment.end_time} ${appointment.description}`;
            }).join('<br />');
            row.find('.appointment-identifier').html(appointmentStrings);
        } else {
            row.find('.appointment-identifier').html('');
        }

        const input = row.find('input');
        input.removeAttr('checked');
        input.val(student.id);
        input.removeAttr('disabled');
        input.attr('id', `student-${student.id}`);
        if (checked) {
            input.attr('checked', 'checked');
        }
        const label = row.find('label');
        label.attr('for', `student-${student.id}`);
    }

    watchInvalidInputs() {
        // use a mutationObserver to check if inputs have the invalid class. Disable the submit button in the same .presence-screen as the input if so
        if (this.observer) {
            this.observer.disconnect();
        }
        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    const input = mutation.target;
                    if (input.tagName !== 'INPUT') {
                        return;
                    }
                    const screen = jQuery(input.closest('.presence-screen'));
                    const submitButton = screen.find('.confirm-button');
                    if (input.classList.contains('invalid') || input.classList.contains('incomplete')) {
                        submitButton.attr('disabled', 'disabled');
                    } else {
                        submitButton.removeAttr('disabled');
                    }
                }
            });
        });
        this.observer.observe(this.wrapper[0], {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true,
        });

        this.wrapper.find('form :input[required]').unbind('keyup.validation').bind('keyup.validation', function() {
            const filled = jQuery(this).val().trim().length > 0;
            jQuery(this).removeClass('incomplete');
            jQuery(this).toggleClass('invalid', !filled);
        }).addClass('incomplete');
    }

    activateScreen(screenId) {
        remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: Activating screen ${screenId}`);
        this.wrapper.children().removeClass('active');
        this.wrapper.children().removeClass('usable');
        const screen = this.wrapper.children(`#${screenId}`);
        screen.addClass('active');

        const cancelButton = screen.find('.cancel-button');
        cancelButton.unbind('click').click(() => {
            remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: Cancel button clicked on screen ${screenId}`);
            this.loadInitScreen();
            return false;
        });

        if (screen.prop('tagName') === 'FORM') {
            screen.unbind('submit').submit(() => {

                remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: Submit button clicked on screen ${screenId}`);
                // blur activeElement
                document.activeElement.blur();
                return false;
            });
            const inputs = screen.find('input[type="text"]');
            inputs.val('');
            inputs.removeClass('invalid');
            inputs.addClass('incomplete');
            inputs.unbind('focus').bind('focus', function() {
                // Scroll up document
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        }

        setTimeout(() => {
            screen.addClass('usable');
        }, PRESENCE_SCREEN_TRANSITION_TIME);

        return screen;
    }

    stopResetTimeout() {
        remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: Stopping reset timeout`);
        this.clearTimeout(this.resetTimeout, 'resetTimeout');
        jQuery('body')
            .unbind('pointerdown')
            .unbind('pointermove')
            .unbind('keydown');
    }

    startResetTimeout() {
        if (this.resetTimeout) {
            this.clearTimeout(this.resetTimeout, 'resetTimeout');
        }
        this.wrapper.removeClass('about-to-reset');
        this.resetTimeout = this.setTimeout(() => {
            remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: Reset timeout expired`);
            this.wrapper.addClass('about-to-reset');
            foundationPopup(`<div class="text-center confirmation-modal-wrapper"><div class="progress-bar"></div><h1>Wilt u verder gaan?</h1><br />Wijzigingen zullen verloren gaan over <span id="seconds">${this.settings.cancelResetTimeout}</span> <span id="units">seconden</span>.<div class="buttons-wrapper"><button class="secondary button">Opnieuw starten</button><button class="primary button">Verder gaan</button></div></div>`, (elm, popup) => {
                elm.find('br:first').remove();
                elm.find('.close-reveal-modal').remove();
                elm.find('.progress-bar').css('animation-duration', `${this.settings.cancelResetTimeout}s`);
                elm.find('button.secondary').click(() => {
                    remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: User chose to restart`);
                    popup.close();
                    this.clearInterval(this.resetCountdown, 'resetCountdown');
                    this.loadInitScreen();
                });
                elm.find('button.primary').click(() => {
                    remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: User chose to continue`);
                    popup.close();
                    this.clearInterval(this.resetCountdown, 'resetCountdown');
                    this.startResetTimeout();
                });
                this.resetCountdown = this.setInterval(() => {
                    const seconds = elm.find('#seconds');
                    const units = elm.find('#units');
                    const secondsValue = parseInt(seconds.text());
                    if (secondsValue === 1) {
                        remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: Reset timeout expired, restarting`);
                        this.clearInterval(this.resetCountdown, 'resetCountdown');
                        popup.close();
                        this.loadInitScreen();
                    } else {
                        if (!this.online) return;
                        seconds.text(secondsValue - 1);
                        units.text(secondsValue - 1 === 1 ? 'seconde' : 'seconden');
                    }
                }, 1000, 'resetCountdown');
            }, 'small')
        }, this.settings.resetTimeout * 1000, 'resetTimeout');

        jQuery('body')
            .unbind('pointerdown')
            .unbind('pointermove')
            .unbind('keydown')
            .on('pointerdown pointermove keydown', () => {
            if (this.wrapper.hasClass('about-to-reset')) return;
            if (this.resetCountdown) this.clearInterval(this.resetCountdown, 'resetCountdown');
            this.clearTimeout(this.resetTimeout, 'resetTimeout');
            this.startResetTimeout();
        });
    }

    applyLogo() {
        // set body::after style
        const style = document.createElement('style');
        const logo = this.settings.logo;
        style.innerHTML = `body::after {
        background-image: url(${logo.url});
        pointer-events: none;
        background-repeat: no-repeat;
        background-position: bottom right;
        width: calc(min(20vw, ${logo.width}px));
        height: calc(min(20vh, ${logo.height}px));
        background-size: contain;
        }`;
        document.head.appendChild(style);
    }

    /**
     * @param field ('birthday' | 'last_name')
     * @param value
     * @param possibleIds
     * @returns {Promise<[]>}
     */
    async findTodaysStudentBy(field, value, possibleIds = []) {
        return await this.get(`findStudentBy/${field}/${value}?possibleIds=${possibleIds.join(',')}`);
    }


    get(path) {
        remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: GET ${path}`);
        return this.api.get(path).catch((error) => {
            this.logError(error);
            alert('Er ging helaas iets mis. Probeer het opnieuw.');
            window.location.reload();
            throw error;
        })
    }
    post(path, data, shouldNotify = true) {
        remoteSupportClient.sendLogToSupport(`[DIGITAL-PRESENCE]: POST ${path} with data ${JSON.stringify(data)}`);
        return this.api.post(path, data).catch((error) => {
            if (shouldNotify) {
                this.logError(error);
                alert('Er ging helaas iets mis. Probeer het opnieuw.');
                window.location.reload();
            }
            throw error;
        })
    }

    static isUsedForDigitalPresence() {
        const clientId = localStorage.getItem('Digital Presence_client_id');
        return clientId !== null;
    }

    setInterval(func, interval, name = 'default') {
        if (!(this.intervals || []).includes(name)) {
            (this.intervals = (this.intervals || [])).push(name);
        }
        this.informTimers();
        return window.setInterval(func, interval);
    }
    setTimeout(func, timeout, name = 'default') {
        if (!(this.timeouts || []).includes(name)) {
            (this.timeouts = (this.timeouts || [])).push(name);
        }
        this.informTimers();
        return window.setTimeout(func, timeout);
    }
    clearInterval(interval, name = 'default') {
        if (this.intervals) {
            this.intervals = this.intervals.filter((intervalName) => {
                return intervalName !== name;
            });
        }
        this.informTimers();
        return window.clearInterval(interval);
    }
    clearTimeout(timeout, name = 'default') {
        if (this.timeouts) {
            this.timeouts = this.timeouts.filter((timeoutName) => {
                return timeoutName !== name;
            });
        }
        this.informTimers();
        return window.clearTimeout(timeout);
    }

    informTimers() {

        const intervalCount = (this.intervals || []).length;
        const timeoutCount = (this.timeouts || []).length;
        const timeouts = this.timeouts || [];
        const intervals = this.intervals || [];
        jQuery('.timer-counts').remove();

        if (!this.debug) {
            return;
        }

        const div = jQuery('<div class="timer-counts"></div>');
        div.text(`Timeouts: ${timeoutCount} (${timeouts.join(', ')})\nIntervals: ${intervalCount} (${intervals.join(', ')})`);
        jQuery('body').append(div);
        jQuery('.timer-counts').css({
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 10000,
            background: 'white',
            padding: '10px',
        });
    }

    logError(e) {
        const errorJsonString = JSON.stringify(e);
        const errors = JSON.parse(localStorage.getItem('digital_presence_errors') || '[]');
        errors.push(errorJsonString);
        localStorage.setItem('digital_presence_errors', JSON.stringify(errors));
    }

    notifyErrors() {
        const errors = JSON.parse(localStorage.getItem('digital_presence_errors') || '[]');
        if (errors.length === 0) return;
        this.post('notifyErrors', { errors }, false).then(() => {
            localStorage.setItem('digital_presence_errors', '[]');
        });
    }

    startLoading() {
        jQuery('body').isLoading('transparent');
    }
    stopLoading() {
        jQuery('body').doneLoading();
    }
}
